import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Box, Avatar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

interface AdminNavbarProps {
  onMenuClick: () => void;
}

const AdminNavbar: React.FC<AdminNavbarProps> = ({ onMenuClick }) => {
  return (
    <AppBar position="sticky" elevation={1} sx={{ backgroundColor: '#ffffff', color: '#1e293b', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar className="flex justify-between items-center px-4 sm:px-6">
        <Box className="flex items-center gap-3">
          {/* Mobile Menu Icon */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={onMenuClick}
            sx={{ display: { lg: 'none' } }}
          >
            <MenuIcon />
          </IconButton>

          {/* Admin Header Title */}
          <div className="flex items-center gap-2">
            <div className="p-1.5 bg-primary-color rounded-lg text-white flex items-center justify-center">
              <AdminPanelSettingsIcon fontSize="medium" />
            </div>
            <Typography variant="h6" className="font-extrabold tracking-tight text-slate-800 text-base sm:text-xl">
              Admin Portal
            </Typography>
          </div>
        </Box>

        {/* Profile Avatar & Metadata */}
        <Box className="flex items-center gap-3">
          <div className="hidden sm:flex flex-col text-right">
            <span className="text-sm font-bold text-slate-800 leading-tight">Administrator</span>
            <span className="text-xs text-slate-500">System Admin</span>
          </div>
          <Avatar sx={{ bgcolor: '#008080', width: 36, height: 36 }} className="font-bold text-sm">
            A
          </Avatar>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AdminNavbar;